import { render, staticRenderFns } from "./salesOrderItem.vue?vue&type=template&id=0d18dbd3&scoped=true&"
import script from "./salesOrderItem.vue?vue&type=script&lang=js&"
export * from "./salesOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./salesOrderItem.vue?vue&type=style&index=0&id=0d18dbd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18dbd3",
  null
  
)

export default component.exports